// extracted by mini-css-extract-plugin
export default {"container":"ComboboxCoso_container__iMM5f","school":"ComboboxCoso_school__lqfvP","logo":"ComboboxCoso_logo__URWN-","name":"ComboboxCoso_name__5WWX7"};